import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;
const orikomiQuote = process.env.REACT_APP_ORIKOMI_QUOTE;

const API_URL_HOLIDAY = baseUrl + "/api/v1/holiday";

const API_URL_GET_BRANDS = orikomiQuote + "/api/v1/brands";

const API_URL_GET_PREFECTURES = orikomiQuote + "/api/v1/prefectures";

const API_URL_EXCEPTIONAL = orikomiQuote + "/api/v1/exceptional_holiday";

// Get Holiday
// @GET
const getHoliday = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.get(API_URL_HOLIDAY + "/read", config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Add Holiday
// @POST
const addHoliday = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.post(API_URL_HOLIDAY + "/add", data, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Delete Holiday
// @POST
const deleteHoliday = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
    data: data,
  };
  // const res = await axios.delete(API_URL_HOLIDAY + '/delete', data, config)
  const res = await axios.delete(API_URL_HOLIDAY + "/delete", config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Exceptional
// Get Brands
// @GET
const getBrands = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.get(API_URL_GET_BRANDS, config);

  return res.data;
};

// Get Prefectures
// @GET
const getPrefectures = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.get(API_URL_GET_PREFECTURES, config);

  return res.data;
};

// Get Exceptional Holiday
// @GET
const getExceptionalHoliday = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.get(API_URL_EXCEPTIONAL + "/read", config);

  return res.data;
};

// Get Add Exceptional Holiday
// @POST
const addExceptionalHoliday = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.post(API_URL_EXCEPTIONAL + "/add", data, config);

  return res.data;
};

// Delete Holiday
// @POST
const deleteExceptionalHoliday = async (data, token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };
  const res = await axios.post(API_URL_EXCEPTIONAL + "/delete", data, config);

  return res.data;
};

const settingService = {
  getHoliday,
  addHoliday,
  deleteHoliday,
  // exceptional
  getExceptionalHoliday,
  getBrands,
  getPrefectures,
  addExceptionalHoliday,
  deleteExceptionalHoliday,
};

export default settingService;
